<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-col cols="12" sm="12" lg="10">
        <v-card>
          <v-toolbar color="light-green darken-1" dark flat>
            <v-toolbar-title>Firmeneinstellungen</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-container class="fill-height" fluid>
              <v-row align="center" justify="center">
                <v-col cols="12" sm="12">
                  <v-form
                    name="customerform"
                    @submit.prevent=""
                    v-model="customerFormValid"
                  >
                    <v-card class="mb-12" color="grey lighten-5">
                      <v-container>
                        <v-row>
                          <v-col cols="12" xs="12" sm="4">
                            <v-text-field
                              label="Kdnr"
                              name="kdnr"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.kdnr"
                              disabled
                            />
                          </v-col>

                          <v-col cols="12" xs="12" sm="8">
                            <v-text-field
                              label="*Name"
                              name="name"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.name"
                              required
                              :rules="requiredRule"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" xs="12" sm="12">
                            <v-text-field
                              label="*Adresse"
                              name="adresse"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.adresse"
                              required
                              :rules="requiredRule"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" xs="12" sm="4">
                            <v-select
                              label="*Land"
                              name="land"
                              :items="countryList"
                              item-text="nameDE"
                              item-value="code"
                              color="purple"
                              :clearable="true"
                              v-model="customer.land"
                              required
                              :rules="requiredRule"
                              disabled
                            />
                          </v-col>
                          <v-col cols="12" xs="12" sm="2">
                            <v-text-field
                              label="*PLZ"
                              name="plz"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.plz"
                              required
                              :rules="requiredRule"
                              disabled
                            />
                          </v-col>
                          <v-col cols="12" xs="12" sm="6">
                            <v-text-field
                              label="*Ort"
                              name="ort"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.ort"
                              required
                              :rules="requiredRule"
                              disabled
                            />
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" xs="12" sm="6">
                            <v-text-field
                              label="Email"
                              name="email"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.email"
                              :rules="requiredEmailRules"
                              disabled
                            />
                          </v-col>

                          <v-col cols="12" xs="12" sm="6">
                            <v-text-field
                              label="Telefon"
                              name="telefon"
                              type="text"
                              color="purple"
                              :clearable="true"
                              v-model="customer.telefon"
                              disabled
                            />
                          </v-col>
                        </v-row>

                        <h3 class="ma-6">Parameter</h3>
                        <v-row>
                          <v-col>
                            <v-switch
                              color="green"
                              v-model="customer.grossgebinde"
                              label="Großgebinde Bestellungen möglich"
                              disabled
                            />
                          </v-col>
                        </v-row>

                        <v-row>
                          <v-col cols="12" sm="12">
                            <v-select
                              v-model="customer.arbeitstage"
                              :items="wochentage"
                              label="Arbeitswochentage"
                              multiple
                              chips
                              dense
                              hint="Reguläre Arbeitstage pro Woche"
                              persistent-hint
                              disabled
                            ></v-select>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col sm="3">
                            <v-text-field
                              label="Bestellende Tage vorher"
                              name="quantity"
                              type="number"
                              color="purple"
                              hint="Stichtag für das Bestellende in Tagen davor"
                              persistent-hint
                              v-model="customer.bestellendeTag"
                              disabled
                            />
                          </v-col>
                          <v-col sm="6" offset-sm="3">
                            <v-text-field
                              type="text"
                              v-model="customer.bestellendeZeit"
                              label="Zeit Bestellende"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="3">
                            <v-switch
                              id="roboter"
                              name="roboter"
                              v-model="customer.roboter"
                              label="Ausgaberoboter"
                              color="success"
                              disabled
                            />
                          </v-col>
                          <v-col sm="9">
                            <v-text-field
                              label="Roboter ID"
                              name="rid"
                              type="text"
                              color="purple"
                              hint="Diese Roboter ID muss direkt beim Roboter für Anfragen gespeichert werden."
                              persistent-hint
                              v-model="customer.roboterId"
                              disabled
                            >
                            </v-text-field>
                          </v-col>
                        </v-row>
                        <v-row>
                          <v-col cols="12" sm="6">
                            <v-text-field
                              label="Roboter Standort"
                              name="standort"
                              type="text"
                              color="purple"
                              disabled
                              v-model="customer.standort"
                            />
                          </v-col>

                          <v-col sm="3">
                            <v-switch
                              id="schichtbetrieb"
                              name="schichtbetrieb"
                              v-model="customer.schichtbetrieb"
                              label="Schichtbetrieb"
                              color="success"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-divider class="ma-6"></v-divider>
                        <h3>Mahlzeiten</h3>
                        <v-row>
                          <v-col sm="4">
                            <v-switch
                              label="Mahlzeit 1"
                              name="meal1"
                              color="success"
                              v-model="customer.mahlzeiten[0].active"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[0].von"
                              label="Mahlzeit 1 von"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[0].bis"
                              label="Mahlzeit 1 bis"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-row v-if="customer.mahlzeiten[1].active">
                          <v-col sm="4">
                            <v-switch
                              label="Mahlzeit 2"
                              name="meal2"
                              color="success"
                              v-model="customer.mahlzeiten[1].active"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[1].von"
                              label="Mahlzeit 2 von"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[1].bis"
                              label="Mahlzeit 2 bis"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-row v-if="customer.mahlzeiten[2].active">
                          <v-col sm="4">
                            <v-switch
                              label="Mahlzeit 3"
                              name="meal3"
                              color="success"
                              v-model="customer.mahlzeiten[2].active"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[2].von"
                              label="Mahlzeit 3 von"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[2].bis"
                              label="Mahlzeit 3 bis"
                              disabled
                            />
                          </v-col>
                        </v-row>
                        <v-row v-if="customer.mahlzeiten[3].active">
                          <v-col sm="4">
                            <v-switch
                              label="Mahlzeit 4"
                              name="meal4"
                              color="success"
                              v-model="customer.mahlzeiten[3].active"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[3].von"
                              label="Mahlzeit 4 von"
                              disabled
                            />
                          </v-col>
                          <v-col sm="4">
                            <v-text-field
                              type="text"
                              v-model="customer.mahlzeiten[3].bis"
                              label="Mahlzeit 4 bis"
                              disabled
                            />
                          </v-col>
                        </v-row>
                      </v-container>
                    </v-card>
                  </v-form>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: "CustomerForm",
  components: {},
  data: () => ({
    customer: {
      _id: null,
      kdnr: "",
      name: "",
      telefon: "",
      email: "",
      adresse: "",
      plz: "",
      ort: "",
      land: "AT",
      arbeitstage: [],
      schichtbetrieb: false,
      standort: "",
      roboter: false,
      grossgebinde: false,
      roboterId: "",
      bestellendeTag: "7",
      bestellendeZeit: "",
      mahlzeiten: [
        {
          active: true,
          von: "",
          bis: ""
        },
        {
          active: false,
          von: "",
          bis: ""
        },
        {
          active: false,
          von: "",
          bis: ""
        },
        {
          active: false,
          von: "",
          bis: ""
        }
      ],
      essenskosten: [
        {
          name: "default",
          amount: 0,
          type: 0,
          perItem: 0
        }
      ]
    },

    wochentage: [
      { text: "Montag", value: 1 },
      { text: "Dienstag", value: 2 },
      { text: "Mittwoch", value: 3 },
      { text: "Donnerstag", value: 4 },
      { text: "Freitag", value: 5 },
      { text: "Samstag", value: 6 },
      { text: "Sonntag", value: 7 }
    ],

    requiredRule: [value => !!value || "Dieses Feld wird benötigt!"],
    emailRules: [
      v =>
        /^$/.test(v) ||
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail Format ungültig"
    ],
    requiredEmailRules: [
      v => !!v || "E-mail wird benötigt!",
      v =>
        /.+@.+/.test(v) ||
        /^\w+([.-]?\w+)*@\w+([.-]?\w+)*(\.\w{2,5})+$/.test(v) ||
        "E-mail Format ungültig"
    ],

    formValid: true,
    customerFormValid: false
  }),

  methods: {},
  computed: {
    countryList() {
      return this.$store.getters["countries/getCountryList"];
    },

    Customer: {
      get() {
        return this.customer;
      },
      set(m) {
        this.customer = m;
      }
    }
  },
  created() {
    const customerId = this.$store.getters["user/getUser"].customerId;
    if (!customerId) {
      this.$notify({
        group: "dataline",
        type: "error",
        title: "Fehler beim laden der Firmendaten",
        text: "Die Firmendaten konnten nicht abgerufen werden"
      });
    }

    this.$store
      .dispatch("customer/fetchCustomer", customerId)

      .then(settings => {
        this.customer = settings.data.data;
      })
      .catch(error => {
        this.$notify({
          group: "dataline",
          type: "error",
          title: "Fehler beim laden der Einstellungen",
          text: error.message
        });
      });
  }
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #ccc;
}
.border-right {
  border-right: 1px solid #ccc;
}

.deleteDepartment:hover {
  color: red;
}

.editDepartment:hover {
  color: green;
}
</style>
